import { Component, Input, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import swal from 'sweetalert2';
import { BillingService } from '../../../services/billing.service';
import { getParamFromAncestorRoute, getQueryParamFromAncestorRoute } from '../../../utilities/route.utilities';


@Component({
    selector: 'payg-payments-by-type-grid-item',
    templateUrl: './payg-payments-by-type-grid-item.component.html',
})
export class PaygPaymentsByTypeGridItemComponent implements OnInit, OnDestroy {

    subscriptions: any[] = [];
    timePeriod: number = 1;
    clientId: number;
    siteId: number;
    agedDebt: any[] = [];
    hasData: boolean = false;
    hasLoading: boolean = true;
    constructor(
        private route: ActivatedRoute,
        private router: Router) {
        this.subscriptions.push(router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.ngOnInit();
            }
        }));
    }

    ngOnInit() {
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    onInfoClick() {
        swal({
            title: 'Payments by type',
            html: '<p style="text-align: left;">This chart displays value by month of all payments (top-up choices) made by consumers in your PAYG portfolio.</p>',
            confirmButtonText: 'Close',
            confirmButtonColor: '#00539f'
        });
    }
}
